import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetMatchLedgerQuery } from '../services/ledger/ledgerApi';
import Loading from '../components/Loading';

function TotalProfitPage() {
  const navigate = useNavigate();
  
  // Get userType from localStorage
  const getUserType = () => {
    try {
      const userData = localStorage.getItem('user_data');
      if (userData) {
        const parsedData = JSON.parse(userData);
        return parsedData.userType;
      }
    } catch (error) {
      console.error('Error parsing user_data from localStorage:', error);
    }
    return null;
  };
  
  const userType = getUserType();
  
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10;

  const [queryParams, setQueryParams] = useState({
    userType: userType,
    share: 'fixed',
    page: 1,
    limit: 10
  });

  const { data: response, isLoading, isFetching, error } = useGetMatchLedgerQuery(queryParams);

  const ledgerData = response?.data || [];
  const total = response?.total || 0;
  const pagination = response?.pagination || {};

  return (
    <div className="">
      <div className="bg-white rounded shadow">
        {/* Header */}
        <div className="bg-[#2c3e3e] text-white px-5 py-3 flex items-center justify-between">
          <h2 className="text-xl font-normal">Match Ledger</h2>
          <button 
            onClick={() => navigate(-1)}
            className="bg-blue-500 text-white px-6 py-2 hover:bg-blue-600"
          >
            Back
          </button>
        </div>

        {/* Total */}
        <div className="p-2 bg-gray-50 flex justify-end">
          <span className="text-base lg:text-lg">
            Total :
            <span className={`font-semibold ml-2 ${total >= 0 ? 'text-green-600' : 'text-red-600'}`}>
              {total >= 0 ? '' : '-'}{Math.abs(total).toFixed(2)}
            </span>
          </span>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          {isLoading || isFetching ? (
            <div className="p-8 flex justify-center">
              <Loading />
            </div>
          ) : error ? (
            <div className="p-4 text-red-500 text-center">
              {error.message || 'Failed to load data'}
            </div>
          ) : (
            <table className="w-full border-collapse">
              <thead className="bg-[#2c3e3e] text-white">
                <tr>
                  <th className="p-3 text-left border border-gray-600">Date</th>
                  <th className="p-3 text-left border border-gray-600">Title</th>
                  <th className="p-3 text-left border border-gray-600">CR</th>
                  <th className="p-3 text-left border border-gray-600">DR</th>
                </tr>
              </thead>
              <tbody>
                {ledgerData?.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="p-4 text-center text-gray-400">
                      No Data
                    </td>
                  </tr>
                ) : (
                  ledgerData?.map((item, index) => (
                    <tr key={index} className="bg-white hover:bg-gray-50">
                      <td className="p-3 border border-gray-300">{item.date}</td>
                      <td className="p-3 border border-gray-300">{item.title}</td>
                      <td className={`p-3 border border-gray-300 ${item.cr > 0 ? 'text-green-600' : ''}`}>
                        {item.cr}
                      </td>
                      <td className={`p-3 border border-gray-300 ${item.dr > 0 ? 'text-red-600' : ''}`}>
                        {item.dr}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}
        </div>

        {/* Pagination */}
        {pagination.totalPages > 0 && (
          <div className="p-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">
            <div className="text-sm text-gray-600">
              Page {pagination.page} of {pagination.totalPages} ({pagination.total} total records)
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => {
                  const newPage = currentPage - 1;
                  setCurrentPage(newPage);
                  setQueryParams({ ...queryParams, page: newPage });
                }}
                disabled={currentPage === 1}
                className="px-4 py-2 bg-blue-500 text-white hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-sm"
              >
                Previous
              </button>
              <button
                onClick={() => {
                  const newPage = currentPage + 1;
                  setCurrentPage(newPage);
                  setQueryParams({ ...queryParams, page: newPage });
                }}
                disabled={currentPage >= pagination.totalPages}
                className="px-4 py-2 bg-blue-500 text-white hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-sm"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TotalProfitPage;
